import {useEffect, useMemo, useState} from 'react';
import {Cita, TemporizadorInfo} from '../services/citasService';

export function deriveReservationTimer(info:TemporizadorInfo, serverNow:number) {
  const scheduled=Date.parse(info.inicio_reserva),start=info.inicio_cobro?Date.parse(info.inicio_cobro):0;
  if(!Number.isFinite(start)||!Number.isFinite(scheduled))return null;
  const elapsed=start?Math.max(0,Math.floor((serverNow-start)/1000)):0;
  const phase=!start?(serverNow<scheduled?'programado':'pendiente_llegada'):serverNow<start?'espera':'en_curso';
  const minutes=Math.floor(elapsed/60);
  const hours=phase==='en_curso'?Math.max(1,Math.ceil(Math.max(0,minutes-info.tolerancia_minutos)/60)):0;
  const initial=Number(info.precio_inicial),later=Number(info.precio_posterior);
  const gross=info.duracion_inicial>0?Math.min(hours,info.duracion_inicial)*initial+Math.max(0,hours-info.duracion_inicial)*later:hours*initial;
  return {phase,elapsed,hours,start,scheduled,wait:Math.max(0,Math.ceil((start-serverNow)/1000)),
    total:Math.round((gross+Number(info.productos_estimados))*100)/100,
    initialPrice:initial+Number(info.productos_estimados),
    nextCharge:start?start+(hours*60+info.tolerancia_minutos+1)*60000:0,
    forecast:start?start+(Math.floor(elapsed/3600)+1)*3600000:Math.max(serverNow,scheduled)+3660000,
    tolerance:info.tolerancia_minutos,
  };
}

export default function useReservationTimer(cita:Cita) {
  const [now,setNow]=useState(Date.now());
  const info=cita.temporizador_info;
  const sync=useMemo(()=>({local:Date.now(),server:info?Date.parse(info.ahora_servidor):NaN}),[info]);
  useEffect(()=>{setNow(Date.now());if(!info)return;const id=window.setInterval(()=>setNow(Date.now()),1000);return()=>window.clearInterval(id);},[info]);
  if(!info||cita.hora_fin!=null||cita.estado==='Cancelada'||cita.estado_ejecucion==='Cancelada'||cita.estado_ejecucion==='Finalizada'||!Number.isFinite(sync.server))return null;
  return deriveReservationTimer(info,sync.server+Math.max(0,now-sync.local));
}

export const timerDuration=(seconds:number)=>[Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].map(n=>String(n).padStart(2,'0')).join(':');
export const timerTime=(timestamp:number)=>new Date(timestamp).toLocaleTimeString('es-BO',{hour:'2-digit',minute:'2-digit',second:'2-digit'});
